import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { PageHeader, StatusBadge, fmtDate } from "@/components/ui-bits";

export default function AdminTickets() {
  const [rows, setRows] = useState([]);
  const [reply, setReply] = useState({});

  const load = async () => { const { data } = await api.get("/admin/tickets"); setRows(data); };
  useEffect(() => { load(); }, []);

  const send = async (id) => {
    const msg = reply[id]?.trim();
    if (!msg) return;
    try {
      await api.post(`/admin/tickets/${id}/reply`, { message: msg });
      toast.success("Replied"); setReply({ ...reply, [id]: "" }); load();
    } catch (e) { toast.error(formatApiError(e)); }
  };
  const close = async (id) => { await api.post(`/admin/tickets/${id}/close`); toast.success("Closed"); load(); };

  return (
    <div>
      <PageHeader title="Support Tickets" />
      <div className="space-y-4">
        {rows.map((t) => (
          <div key={t.id} className="glass p-5">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-display font-bold text-lg">{t.subject}</div>
                <div className="text-xs text-[#94A3B8] mt-1">{t.user_name} · {fmtDate(t.created_at)}</div>
              </div>
              <StatusBadge status={t.status} />
            </div>
            <div className="text-sm text-[#94A3B8] mt-3 whitespace-pre-line">{t.message}</div>
            {t.replies?.length > 0 && (
              <div className="mt-4 space-y-2 border-t border-white/5 pt-3">
                {t.replies.map((r, i) => (
                  <div key={i} className="bg-[#00F0FF]/5 border-l-2 border-[#00F0FF]/40 px-3 py-2 rounded-r">
                    <div className="text-xs text-[#00F0FF] uppercase tracking-wider font-bold">{r.by} · {fmtDate(r.created_at)}</div>
                    <div className="text-sm mt-1">{r.message}</div>
                  </div>
                ))}
              </div>
            )}
            {t.status === "open" && (
              <div className="mt-4 flex gap-2">
                <input value={reply[t.id] || ""} onChange={(e) => setReply({ ...reply, [t.id]: e.target.value })}
                       placeholder="Reply…" data-testid={`reply-input-${t.id}`}
                       className="flex-1 bg-[#0A132A] border border-white/10 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#00F0FF]" />
                <button onClick={() => send(t.id)} data-testid={`reply-send-${t.id}`} className="px-4 py-2 bg-[#00F0FF] text-[#060B19] font-bold rounded-lg text-sm hover:bg-[#00D4E0]">Send</button>
                <button onClick={() => close(t.id)} data-testid={`close-${t.id}`} className="px-4 py-2 bg-red-500/15 text-red-300 border border-red-500/30 rounded-lg text-sm">Close</button>
              </div>
            )}
          </div>
        ))}
        {rows.length === 0 && <div className="text-[#475569] text-sm py-6 text-center">No tickets</div>}
      </div>
    </div>
  );
}
